import { ChangeDetectorRef, Component, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { WorkflowService } from '../workflow/workflow.service';
import { CommonService } from '../../services/common.service';
import { GlobalService } from '../../services/global.service';
import { RetrievalService } from '../retrieval/retrieval.service';
import { MatDialog } from '@angular/material/dialog';
import { DocumentViewerService } from './document-viewer.service';
import { TransitionRules, WorkItemResponseDto } from '../../models/workItemResponseDto';
import { WorkflowHistoryResponse } from '../../models/workflow-history.model';
import { WorkflowHistoryDialogComponent } from '../../shared/workflow-history-dialog/workflow-history-dialog.component';
import { DocumentHistoryResponse } from '../../models/document-history.model';
import { DocumentHistoryDialogComponent } from '../../shared/document-history-dialog/document-history-dialog.component';
import { ViewAddDocNotesComponent } from '../../shared/view-add-doc-notes/view-add-doc-notes.component';
import { ViewWorkflowNotesComponent } from '../../shared/view-workflow-notes/view-workflow-notes.component';
import { IndexFields } from '../../models/index-fields';
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { environment } from '../../../environments/environment';
import { DocInfo, EmailInfo } from '../../models/documentInfoDto';
import { SendEmailComponent } from '../../shared/send-email/send-email.component';
import { AddAttachmentComponent } from '../../shared/add-attachment/add-attachment.component';
import { DialogComponent, DialogData } from '../../shared/dialog/dialog.component';
import { MoveWorkItemDto, NextWorkItem, SaveDocHistoryDto } from '../../models/moveWorkItemDto';
import { AppContext } from '../../models/appContext';
import { VendorEmailDto } from '../../models/vendorEmailDto';
import { ReAssignReleaseDto } from '../../models/reAssignReleaseDto';
import { UserSystemPreference } from '../../models/userSystemPreference';
import moment from 'moment';
import { DynamicDateAdapter } from '../../common/dynamic-date-adapter';
import { DateAdapter } from '@angular/material/core';
import { BatchDocuments, BatchNode } from '../../models/batchDocuments'; 
import { map, Observable, startWith } from 'rxjs';
import { GPID } from '../../models/GPID';
import { LineItemsGlEntryComponent } from '../../shared/line-items-gl-entry/line-items-gl-entry.component';
import { DateService } from '../../services/date.service';

@Component({
  selector: 'app-document-viewer',
  templateUrl: './document-viewer.component.html',
  styleUrl: './document-viewer.component.scss',
})
export class DocumentViewerComponent {
  selectedQueue: string = "";
  link: any;
  RTVQueueCheck: any = '-1';
  reRoute: boolean = false;
  isRoutingComplete: boolean = false;
  Workitemdetails: string | TransitionRules | undefined;
  pendingItemToProcess: TransitionRules | string | null = null;
  checkForNextWorkItem: boolean = false;
  isNextWorkItemAvailable: boolean = false;
  pQueueId!: string;
  pDocId!: string;
  pInstanceId!: string;
  pPageType!: string;
  pBatchId!: string;
  selectedSystemId: any;
  userGPID: any;
  source!: string;
  isEditableGLEntryTable: boolean = false;
  isVendorIntercompany: boolean = false;
  isWIInCustOrNonPOApprovalQueues: boolean = false;
  isCustGLEntryTableDisplay: boolean = false;
  isCustWorkFlowBaName: string = "";
  isCodingFieldUpdateRequired: boolean = false;
  isGLEntrySaved: boolean = false;
  @ViewChild('lineItemsGlEntry') lineItemsGlEntryComponent!: LineItemsGlEntryComponent;
  workFlowViewEmitter = {
    MY_WORKITEMS_BASKET: "001",
    WORKFLOW: "002",
    RETRIEVAL: "003",
  };
  routingButtons: TransitionRules[] = [];
  resetRoutingButtons: TransitionRules[] = [];
  setRoutingButtons: TransitionRules[] = [];
  canReturn: boolean | undefined = false;
  isReturnClicked: boolean | undefined = false;
  previousQueueName: string | undefined;
  QueueId: number = 0;
  previousQueueId: number | undefined;
  workFlowID: number = 0;
  owningUser!: string;
  referenceType: string | undefined;
  documentTypeId: number | undefined;
  documentTypeIdForGL: number = 0;
  fromQueue: string | undefined;
  sendautoEmail: boolean | undefined;
  WITitle: string | undefined;
  documentTypeForQueue: any[] = [];
  selDocumentType: string = "";
  mappedCompanyCode: string = "";
  nextDocType!: string | null;
  wiLockedInfoAsString: any;
  isEmailToRequestorMenu: boolean | undefined;
  isRetrieval: boolean = false;
  ImageId: number = 0;
  getPoNumber: any;
  selectedPreferenceValue: string | null = "";
  documentIndexFieldValues: IndexFields[] = [];
  indexForm: FormGroup = this.fb.group({
    fields: this.fb.array([])
  });
  emailInfo: EmailInfo = {
    id: '',
    type: '',
    documentInfo: undefined,
    toMail: '',
    userGpid: '',
    systemId: ''
  };
  expandedNodes = new Set<BatchNode>();
  expandedNodeIds = new Set<string>();
  dataSource: BatchNode[] = [];
  childrenAccessor = (node: BatchNode) => node.children ?? [];
  hasChild = (_: number, node: BatchNode) => !!node.children && node.children.length > 0;
  Queuedetails: any = {};
  isAdvanceDoc: boolean = false;
  isAdmin: boolean = false;
  isApprover: boolean = false;
  isWorkflowRetrievalApproverOnly: boolean = false;
  isWorkflowRetrievalVendorClassificationRoleAccess: boolean = false;
  isWorkflowRetrievalRoleAccess: boolean = false;
  isBatchSelected: boolean = false;
  error: boolean = false;
  isLoading: boolean = true;
  loaderMsg: string = '';
  documentSourceUrl: string = '';
  @ViewChildren('dp') datePickers!: QueryList<MatDatepicker<Date>>;
  iframeCollapsed = false;
  documentList: DocInfo[] = [];
  userSystemPreferencedata: UserSystemPreference[] = [];
  selectResults: IndexFields[] = [];
  copyQueueIds = [
    48, 50, 51, 58, 164, 277, 288, 350, 351, 352, 8895, 8897, 8898, 8905,
    8910, 8911, 8912, 8913, 8915, 8916, 8927, 8938,
  ];
  currentStorageRepoId: string = "";
  isCopyEnabled: boolean = false;
  initalLoad: boolean = false;
  isViewerEnabledDefault: boolean = false;
  selectedDocumentId: string = "";
  isSelectResultsLoading: boolean = false;
  isSelectResultsAvailable: boolean = false;
  isReadOnly: boolean = false;
  isSendDocRecycleEnabled: boolean = false;
  isSendNewBatchEnabled: boolean = false;
  isAdvanceInitiatorAsApprover: boolean = false;
  pStorageRepoId: string = "";
  isPoNumberError: boolean = false;
  isViewMasterBatchEnabled: boolean = false;
  isEmailRequestorError: boolean = false;
  missingFields: boolean = false;
  isRoutingButton: boolean = true;
  AdvanceInitiator: boolean = false;
  RTVContactEmailId: string = "";
  InvoiceNumber: string = "";
  RTVOtherDescription: string = "";
  supplierCountry: string = "";
  DocumentType: string = "";
  VendorId: string = "";
  CompanyCodeID: string = "";
  RTVReasonCode: string = "";
  vendorMailResponse: VendorEmailDto | undefined;
  isDocumentView = true;
  getSearchBoxVal: boolean = false;
  batchLoading: boolean = false;
  selectedIndex: number = 0;
  selectedBatchIndex: number = 0;
  isDocumentsNotAvailable: boolean = false;
  batchHierarchyInfo: any[] = [];
  documentProperties: any;
  AssignedUser: any;
  workFlowNotesMenu = "View Workflow Notes";
  documentNotesMenu = "View Document Notes";
  selectedDocument: DocInfo | null = null;
  fieldFormats: Map<number, string> = new Map();
  selectedNodeValue: any = null;
  abbyyBatchId?: string;
  docId?: string;
  abbyyDocId?: string;
  isRoutingBtnLoading: boolean = true;
  isIndexFieldsLoading: boolean = true;
  isAttachmentLoading: boolean = true;
  isBatchViewLoading: boolean = true;
  isDynamicMandatoryActive = false;
  userFilteredOptionsMap: { [key: number]: Observable<GPID[]> } = {};
  gpids: GPID[] = [];
  totalGlEntries: number = 0;
  vendorerpId: string = "";
  private dynamicMandatoryFieldIds: number[] = [];
  // Define queue-field rules as an array of objects
  readonly queueTransitionMandatoryRules: {
    [key: number]: { fromQueueId: number; toQueueId: number; fieldId: number; isReturn?: boolean }[];
  } = {
      6000: [
        { fromQueueId: 69, toQueueId: 82, fieldId: 218 },
        { fromQueueId: 71, toQueueId: 82, fieldId: 220 },
        { fromQueueId: 73, toQueueId: 82, fieldId: 222 },
        { fromQueueId: 75, toQueueId: 82, fieldId: 224 },
        { fromQueueId: 77, toQueueId: 82, fieldId: 226 },
        { fromQueueId: 29, toQueueId: 30, fieldId: 219 },
        { fromQueueId: 31, toQueueId: 27, fieldId: 218 },
        { fromQueueId: 32, toQueueId: 27, fieldId: 220 },
        { fromQueueId: 33, toQueueId: 27, fieldId: 222 },
        { fromQueueId: 34, toQueueId: 27, fieldId: 224 },
        { fromQueueId: 35, toQueueId: 27, fieldId: 226 },
        { fromQueueId: 131, toQueueId: 142, fieldId: 317 },
        { fromQueueId: 133, toQueueId: 142, fieldId: 319 },
        { fromQueueId: 135, toQueueId: 142, fieldId: 321 },
        { fromQueueId: 137, toQueueId: 142, fieldId: 323 },
        { fromQueueId: 139, toQueueId: 142, fieldId: 325 },
        { fromQueueId: 88, toQueueId: 89, fieldId: 318 },
        { fromQueueId: 88, toQueueId: 100, fieldId: 407 },
        { fromQueueId: 90, toQueueId: 100, fieldId: 317 },
        { fromQueueId: 91, toQueueId: 100, fieldId: 319 },
        { fromQueueId: 92, toQueueId: 100, fieldId: 321 },
        { fromQueueId: 93, toQueueId: 100, fieldId: 323 },
        { fromQueueId: 94, toQueueId: 100, fieldId: 325 },
        { fromQueueId: 145, toQueueId: 45, fieldId: 308 },
        { fromQueueId: 146, toQueueId: 49, fieldId: 308 },
        { fromQueueId: 147, toQueueId: 60, fieldId: 308 },
        { fromQueueId: 148, toQueueId: 24, fieldId: 308 },
        { fromQueueId: 149, toQueueId: 107, fieldId: 407 },
        { fromQueueId: 150, toQueueId: 111, fieldId: 407 },
        { fromQueueId: 151, toQueueId: 122, fieldId: 407 },
        { fromQueueId: 152, toQueueId: 86, fieldId: 407 },
        { fromQueueId: 156, toQueueId: 126, fieldId: 407 },
        { fromQueueId: 155, toQueueId: 114, fieldId: 407 },
        { fromQueueId: 154, toQueueId: 64, fieldId: 308 },
        { fromQueueId: 153, toQueueId: 54, fieldId: 308 },
        { fromQueueId: 29, toQueueId: 27, fieldId: 308 },
        { fromQueueId: 68, toQueueId: 82, fieldId: 308 },
        { fromQueueId: 130, toQueueId: 142, fieldId: 407 },
        { fromQueueId: 130, toQueueId: 141, fieldId: 315 },
        { fromQueueId: 130, toQueueId: 141, fieldId: 398 },
        { fromQueueId: 130, toQueueId: 141, fieldId: 318 },
        { fromQueueId: 68, toQueueId: 79, fieldId: 216 },
        { fromQueueId: 68, toQueueId: 79, fieldId: 299 },
        { fromQueueId: 68, toQueueId: 79, fieldId: 219 },
        { fromQueueId: 80, toQueueId: 158, fieldId: 308 },
        { fromQueueId: 143, toQueueId: 157, fieldId: 407 },
        { fromQueueId: 378, toQueueId: 380, fieldId: 1105 }
      ],
      6001: [
        { fromQueueId: 277, toQueueId: 269, fieldId: 1101 },
        { fromQueueId: 258, toQueueId: 256, fieldId: 1101 },
        { fromQueueId: 270, toQueueId: 386, fieldId: 1101 },
        { fromQueueId: 271, toQueueId: 386, fieldId: 1101 },
        { fromQueueId: 272, toQueueId: 386, fieldId: 1101 },
        { fromQueueId: 273, toQueueId: 386, fieldId: 1101 },
        { fromQueueId: 274, toQueueId: 386, fieldId: 1101 },
        { fromQueueId: 275, toQueueId: 386, fieldId: 1101 },
        { fromQueueId: 276, toQueueId: 386, fieldId: 1101 },
        { fromQueueId: 264, toQueueId: 262, fieldId: 1101 },
        { fromQueueId: 224, toQueueId: 223, fieldId: 1101 },
        { fromQueueId: 230, toQueueId: 228, fieldId: 1101 },
        { fromQueueId: 370, toQueueId: 373, fieldId: 1101 },
        { fromQueueId: 196, toQueueId: 194, fieldId: 1101 },
        { fromQueueId: 197, toQueueId: 198, fieldId: 709 },
        { fromQueueId: 197, toQueueId: 209, fieldId: 1101 },
        { fromQueueId: 199, toQueueId: 209, fieldId: 708 },
        { fromQueueId: 200, toQueueId: 209, fieldId: 710 },
        { fromQueueId: 201, toQueueId: 209, fieldId: 712 },
        { fromQueueId: 202, toQueueId: 209, fieldId: 714 },
        { fromQueueId: 203, toQueueId: 209, fieldId: 716 },
        { fromQueueId: 218, toQueueId: 216, fieldId: 1101 },
        { fromQueueId: 231, toQueueId: 232, fieldId: 709 },
        { fromQueueId: 231, toQueueId: 243, fieldId: 1101 },
        { fromQueueId: 233, toQueueId: 243, fieldId: 708 },
        { fromQueueId: 234, toQueueId: 243, fieldId: 710 },
        { fromQueueId: 235, toQueueId: 243, fieldId: 712 },
        { fromQueueId: 236, toQueueId: 243, fieldId: 714 },
        { fromQueueId: 237, toQueueId: 243, fieldId: 716 },
        { fromQueueId: 252, toQueueId: 250, fieldId: 1101 },
        { fromQueueId: 369, toQueueId: 361, fieldId: 1102 },
        { fromQueueId: 350, toQueueId: 348, fieldId: 1102 },
        { fromQueueId: 362, toQueueId: 390, fieldId: 1102 },
        { fromQueueId: 363, toQueueId: 390, fieldId: 1102 },
        { fromQueueId: 364, toQueueId: 390, fieldId: 1102 },
        { fromQueueId: 365, toQueueId: 390, fieldId: 1102 },
        { fromQueueId: 366, toQueueId: 390, fieldId: 1102 },
        { fromQueueId: 367, toQueueId: 390, fieldId: 1102 },
        { fromQueueId: 368, toQueueId: 390, fieldId: 1102 },
        { fromQueueId: 356, toQueueId: 354, fieldId: 1102 },
        { fromQueueId: 316, toQueueId: 315, fieldId: 1102 },
        { fromQueueId: 322, toQueueId: 320, fieldId: 1102 },
        { fromQueueId: 371, toQueueId: 282, fieldId: 1102 },
        { fromQueueId: 288, toQueueId: 286, fieldId: 1102 },
        { fromQueueId: 289, toQueueId: 290, fieldId: 808 },
        { fromQueueId: 289, toQueueId: 301, fieldId: 1102 },
        { fromQueueId: 291, toQueueId: 301, fieldId: 807 },
        { fromQueueId: 292, toQueueId: 301, fieldId: 809 },
        { fromQueueId: 293, toQueueId: 301, fieldId: 811 },
        { fromQueueId: 294, toQueueId: 301, fieldId: 813 },
        { fromQueueId: 295, toQueueId: 301, fieldId: 815 },
        { fromQueueId: 310, toQueueId: 308, fieldId: 1102 },
        { fromQueueId: 323, toQueueId: 324, fieldId: 808 },
        { fromQueueId: 323, toQueueId: 335, fieldId: 1102 },
        { fromQueueId: 325, toQueueId: 335, fieldId: 807 },
        { fromQueueId: 326, toQueueId: 335, fieldId: 809 },
        { fromQueueId: 327, toQueueId: 335, fieldId: 811 },
        { fromQueueId: 328, toQueueId: 335, fieldId: 813 },
        { fromQueueId: 329, toQueueId: 335, fieldId: 815 },
        { fromQueueId: 344, toQueueId: 342, fieldId: 1102 },        
        { fromQueueId: 270, toQueueId: 385, fieldId: 724 },
        { fromQueueId: 271, toQueueId: 385, fieldId: 724 },
        { fromQueueId: 272, toQueueId: 385, fieldId: 724 },
        { fromQueueId: 273, toQueueId: 385, fieldId: 724 },
        { fromQueueId: 274, toQueueId: 385, fieldId: 724 },
        { fromQueueId: 275, toQueueId: 385, fieldId: 724 },
        { fromQueueId: 276, toQueueId: 385, fieldId: 724 },
        { fromQueueId: 362, toQueueId: 389, fieldId: 823 },
        { fromQueueId: 363, toQueueId: 389, fieldId: 823 },
        { fromQueueId: 364, toQueueId: 389, fieldId: 823 },
        { fromQueueId: 365, toQueueId: 389, fieldId: 823 },
        { fromQueueId: 366, toQueueId: 389, fieldId: 823 },
        { fromQueueId: 367, toQueueId: 389, fieldId: 823 },
        { fromQueueId: 368, toQueueId: 389, fieldId: 823 }
      ],
    6002: [
      { fromQueueId: 428, toQueueId: 429, fieldId: 1203 },
      { fromQueueId: 438, toQueueId: 437, fieldId: 1203 },
      { fromQueueId: 441, toQueueId: 442, fieldId: 1203 },
      { fromQueueId: 446, toQueueId: 448, fieldId: 1203 },
      { fromQueueId: 452, toQueueId: 456, fieldId: 1203 },
      { fromQueueId: 491, toQueueId: 490, fieldId: 1203 },
      { fromQueueId: 485, toQueueId: 483, fieldId: 1203 },
      { fromQueueId: 505, toQueueId: 506, fieldId: 1205 },
      { fromQueueId: 505, toQueueId: 501, fieldId: 1203 },
      { fromQueueId: 507, toQueueId: 501, fieldId: 1204 },
      { fromQueueId: 492, toQueueId: 501, fieldId: 1206 },
      { fromQueueId: 493, toQueueId: 501, fieldId: 1208 },
      { fromQueueId: 494, toQueueId: 501, fieldId: 1210 },
      { fromQueueId: 495, toQueueId: 501, fieldId: 1212 },
      { fromQueueId: 513, toQueueId: 511, fieldId: 1203 },
      { fromQueueId: 468, toQueueId: 469, fieldId: 1205 },
      { fromQueueId: 468, toQueueId: 465, fieldId: 1203 },
      { fromQueueId: 470, toQueueId: 465, fieldId: 1204 },
      { fromQueueId: 471, toQueueId: 465, fieldId: 1206 },
      { fromQueueId: 472, toQueueId: 465, fieldId: 1208 },
      { fromQueueId: 459, toQueueId: 465, fieldId: 1210 },
      { fromQueueId: 462, toQueueId: 465, fieldId: 1212 },
      { fromQueueId: 474, toQueueId: 476, fieldId: 1203 },
      { fromQueueId: 413, toQueueId: 411, fieldId: 1204 },
      { fromQueueId: 426, toQueueId: 411, fieldId: 1206 },
      { fromQueueId: 423, toQueueId: 411, fieldId: 1208 },
      { fromQueueId: 421, toQueueId: 411, fieldId: 1210 },
      { fromQueueId: 419, toQueueId: 411, fieldId: 1212 },
      { fromQueueId: 417, toQueueId: 411, fieldId: 1203 },
      { fromQueueId: 896, toQueueId: 411, fieldId: 1203 },
      { fromQueueId: 415, toQueueId: 411, fieldId: 1203 },
      { fromQueueId: 428, toQueueId: 429, fieldId: 1203 },
      { fromQueueId: 438, toQueueId: 437, fieldId: 1203 },
      { fromQueueId: 441, toQueueId: 442, fieldId: 1203 },
      { fromQueueId: 412, toQueueId: 411, fieldId: 1203 },
      { fromQueueId: 416, toQueueId: 411, fieldId: 1203 },
      { fromQueueId: 895, toQueueId: 411, fieldId: 1203 },
      { fromQueueId: 886, toQueueId: 888, fieldId: 2563 },
      { fromQueueId: 799, toQueueId: 800, fieldId: 1962 },
      { fromQueueId: 809, toQueueId: 808, fieldId: 1962 },
      { fromQueueId: 812, toQueueId: 813, fieldId: 1962 },
      { fromQueueId: 817, toQueueId: 819, fieldId: 1962 },
      { fromQueueId: 823, toQueueId: 827, fieldId: 1962 },
      { fromQueueId: 862, toQueueId: 861, fieldId: 1962 },
      { fromQueueId: 856, toQueueId: 854, fieldId: 1962 },
      { fromQueueId: 876, toQueueId: 877, fieldId: 1964 },
      { fromQueueId: 876, toQueueId: 872, fieldId: 1962 },
      { fromQueueId: 878, toQueueId: 872, fieldId: 1963 },
      { fromQueueId: 863, toQueueId: 872, fieldId: 1965 },
      { fromQueueId: 864, toQueueId: 872, fieldId: 1967 },
      { fromQueueId: 865, toQueueId: 872, fieldId: 1969 },
      { fromQueueId: 866, toQueueId: 872, fieldId: 1971 },
      { fromQueueId: 884, toQueueId: 882, fieldId: 1962 },
      { fromQueueId: 839, toQueueId: 840, fieldId: 1964 },
      { fromQueueId: 839, toQueueId: 836, fieldId: 1962 },
      { fromQueueId: 841, toQueueId: 836, fieldId: 1963 },
      { fromQueueId: 842, toQueueId: 836, fieldId: 1965 },
      { fromQueueId: 843, toQueueId: 836, fieldId: 1967 },
      { fromQueueId: 830, toQueueId: 836, fieldId: 1969 },
      { fromQueueId: 833, toQueueId: 836, fieldId: 1971 },
      { fromQueueId: 845, toQueueId: 847, fieldId: 1962 },
      { fromQueueId: 778, toQueueId: 780, fieldId: 2365 },
      { fromQueueId: 691, toQueueId: 692, fieldId: 1863 },
      { fromQueueId: 701, toQueueId: 700, fieldId: 1863 },
      { fromQueueId: 704, toQueueId: 705, fieldId: 1863 },
      { fromQueueId: 709, toQueueId: 711, fieldId: 1863 },
      { fromQueueId: 715, toQueueId: 719, fieldId: 1863 },
      { fromQueueId: 754, toQueueId: 753, fieldId: 1863 },
      { fromQueueId: 748, toQueueId: 746, fieldId: 1863 },
      { fromQueueId: 768, toQueueId: 769, fieldId: 1865 },
      { fromQueueId: 768, toQueueId: 764, fieldId: 1863 },
      { fromQueueId: 770, toQueueId: 764, fieldId: 1864 },
      { fromQueueId: 755, toQueueId: 764, fieldId: 1866 },
      { fromQueueId: 756, toQueueId: 764, fieldId: 1868 },
      { fromQueueId: 757, toQueueId: 764, fieldId: 1870 },
      { fromQueueId: 758, toQueueId: 764, fieldId: 1872 },
      { fromQueueId: 776, toQueueId: 774, fieldId: 1863 },
      { fromQueueId: 731, toQueueId: 732, fieldId: 1865 },
      { fromQueueId: 731, toQueueId: 728, fieldId: 1863 },
      { fromQueueId: 733, toQueueId: 728, fieldId: 1864 },
      { fromQueueId: 734, toQueueId: 728, fieldId: 1866 },
      { fromQueueId: 735, toQueueId: 728, fieldId: 1868 },
      { fromQueueId: 722, toQueueId: 728, fieldId: 1870 },
      { fromQueueId: 725, toQueueId: 728, fieldId: 1872 },
      { fromQueueId: 737, toQueueId: 739, fieldId: 1863 },
      { fromQueueId: 670, toQueueId: 672, fieldId: 2167 },
      { fromQueueId: 583, toQueueId: 584, fieldId: 1764 },
      { fromQueueId: 593, toQueueId: 592, fieldId: 1764 },
      { fromQueueId: 596, toQueueId: 597, fieldId: 1764 },
      { fromQueueId: 601, toQueueId: 603, fieldId: 1764 },
      { fromQueueId: 607, toQueueId: 611, fieldId: 1764 },
      { fromQueueId: 646, toQueueId: 645, fieldId: 1764 },
      { fromQueueId: 640, toQueueId: 638, fieldId: 1764 },
      { fromQueueId: 660, toQueueId: 661, fieldId: 1766 },
      { fromQueueId: 660, toQueueId: 656, fieldId: 1764 },
      { fromQueueId: 662, toQueueId: 656, fieldId: 1765 },
      { fromQueueId: 647, toQueueId: 656, fieldId: 1767 },
      { fromQueueId: 648, toQueueId: 656, fieldId: 1769 },
      { fromQueueId: 649, toQueueId: 656, fieldId: 1771 },
      { fromQueueId: 650, toQueueId: 656, fieldId: 1773 },
      { fromQueueId: 668, toQueueId: 666, fieldId: 1764 },
      { fromQueueId: 623, toQueueId: 624, fieldId: 1766 },
      { fromQueueId: 623, toQueueId: 620, fieldId: 1764 },
      { fromQueueId: 625, toQueueId: 620, fieldId: 1765 },
      { fromQueueId: 626, toQueueId: 620, fieldId: 1767 },
      { fromQueueId: 627, toQueueId: 620, fieldId: 1769 },
      { fromQueueId: 614, toQueueId: 620, fieldId: 1771 },
      { fromQueueId: 617, toQueueId: 620, fieldId: 1773 },
      { fromQueueId: 629, toQueueId: 631, fieldId: 1764 },
      { fromQueueId: 790, toQueueId: 791, fieldId: 1979 },
      { fromQueueId: 790, toQueueId: 793, fieldId: 1962 },
      { fromQueueId: 794, toQueueId: 793, fieldId: 1962 },
      { fromQueueId: 795, toQueueId: 794, fieldId: 1962 },
      { fromQueueId: 796, toQueueId: 794, fieldId: 1962 },
      { fromQueueId: 909, toQueueId: 911, fieldId: 2771 },
      { fromQueueId: 682, toQueueId: 683, fieldId: 1880 },
      { fromQueueId: 682, toQueueId: 685, fieldId: 1863 },
      { fromQueueId: 686, toQueueId: 685, fieldId: 1863 },
      { fromQueueId: 687, toQueueId: 686, fieldId: 1863 },
      { fromQueueId: 688, toQueueId: 686, fieldId: 1863 },
      { fromQueueId: 905, toQueueId: 907, fieldId: 2671 },
      { fromQueueId: 947, toQueueId: 958, fieldId: 1765 },
      { fromQueueId: 949, toQueueId: 958, fieldId: 1767 },
      { fromQueueId: 951, toQueueId: 958, fieldId: 1769 },
      { fromQueueId: 953, toQueueId: 958, fieldId: 1771 },
      { fromQueueId: 955, toQueueId: 958, fieldId: 1773 },
      { fromQueueId: 582, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 566, toQueueId: 960, fieldId: 1781 },
      { fromQueueId: 566, toQueueId: 577, fieldId: 1764 },
      { fromQueueId: 579, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 579, toQueueId: 960, fieldId: 1781 },
      { fromQueueId: 580, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 581, toQueueId: 582, fieldId: 1766 },
      { fromQueueId: 581, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 913, toQueueId: 915, fieldId: 2871 },
      { fromQueueId: 566, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 567, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 568, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 569, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 570, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 571, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 572, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 573, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 574, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 575, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 576, toQueueId: 958, fieldId: 1764 },
      { fromQueueId: 515, toQueueId: 517, fieldId: 1477 },
      { fromQueueId: 515, toQueueId: 517, fieldId: 1534 },
      { fromQueueId: 515, toQueueId: 517, fieldId: 1517 },
      { fromQueueId: 515, toQueueId: 516, fieldId: 1534 },
      { fromQueueId: 515, toQueueId: 516, fieldId: 1517 },
      { fromQueueId: 567, toQueueId: 960, fieldId: 1781 },
      { fromQueueId: 568, toQueueId: 960, fieldId: 1781 },
      { fromQueueId: 569, toQueueId: 960, fieldId: 1781 },
      { fromQueueId: 570, toQueueId: 960, fieldId: 1781 },
      { fromQueueId: 571, toQueueId: 960, fieldId: 1781 },
      { fromQueueId: 572, toQueueId: 960, fieldId: 1781 },
      { fromQueueId: 573, toQueueId: 960, fieldId: 1781 },
      { fromQueueId: 574, toQueueId: 960, fieldId: 1781 },
      { fromQueueId: 575, toQueueId: 960, fieldId: 1781 },
      { fromQueueId: 576, toQueueId: 960, fieldId: 1781 },
      { fromQueueId: 967, toQueueId: 794, fieldId: 1962 },
      { fromQueueId: 968, toQueueId: 686, fieldId: 1863 },
      { fromQueueId: 794, toQueueId: 790, fieldId: 1962, isReturn: true },
      { fromQueueId: 686, toQueueId: 682, fieldId: 1863, isReturn: true },
      { fromQueueId: 577, toQueueId: 566, fieldId: 1764, isReturn: true },
      { fromQueueId: 577, toQueueId: 567, fieldId: 1764, isReturn: true },
      { fromQueueId: 577, toQueueId: 568, fieldId: 1764, isReturn: true },
      { fromQueueId: 577, toQueueId: 569, fieldId: 1764, isReturn: true },
      { fromQueueId: 577, toQueueId: 570, fieldId: 1764, isReturn: true },
      { fromQueueId: 577, toQueueId: 571, fieldId: 1764, isReturn: true },
      { fromQueueId: 577, toQueueId: 572, fieldId: 1764, isReturn: true },
      { fromQueueId: 577, toQueueId: 573, fieldId: 1764, isReturn: true },
      { fromQueueId: 577, toQueueId: 574, fieldId: 1764, isReturn: true },
      { fromQueueId: 577, toQueueId: 575, fieldId: 1764, isReturn: true },
      { fromQueueId: 577, toQueueId: 576, fieldId: 1764, isReturn: true },
    ]
    };

  readonly editableGLEntryRules: Readonly<{
    [key: number]: ReadonlyArray<{ workflowId: number; queueId: number }>
  }> = {
  6000: [
    { workflowId: 14, queueId: 90 },
    { workflowId: 4, queueId: 31 },
    { workflowId: 14, queueId: 88 },
    { workflowId: 4, queueId: 29 },
    { workflowId: 20, queueId: 131 },
    { workflowId: 12, queueId: 69 },
    { workflowId: 20, queueId: 143 },
    { workflowId: 12, queueId: 80 }
  ],
  6001: [
    { workflowId: 173, queueId: 197 },
    { workflowId: 173, queueId: 199 },
    { workflowId: 175, queueId: 231 },
    { workflowId: 175, queueId: 233 },
    { workflowId: 184, queueId: 289 },
    { workflowId: 184, queueId: 291 },
    { workflowId: 186, queueId: 325 },
    { workflowId: 186, queueId: 323 }
  ],
  6002: [
    { workflowId: 407, queueId: 505 },
    { workflowId: 407, queueId: 507 },
    { workflowId: 403, queueId: 468 },
    { workflowId: 403, queueId: 470 },
    { workflowId: 397, queueId: 413 },
    { workflowId: 397, queueId: 895 },
    { workflowId: 397, queueId: 415 },
    { workflowId: 397, queueId: 896 },
    { workflowId: 562, queueId: 876 },
    { workflowId: 562, queueId: 878 },
    { workflowId: 558, queueId: 839 },
    { workflowId: 558, queueId: 841 },
    { workflowId: 549, queueId: 768 },
    { workflowId: 549, queueId: 770 },
    { workflowId: 545, queueId: 731 },
    { workflowId: 545, queueId: 733 },
    { workflowId: 536, queueId: 660 },
    { workflowId: 536, queueId: 662 },
    { workflowId: 532, queueId: 623 },
    { workflowId: 532, queueId: 625 },
    { workflowId: 552, queueId: 794 },
    { workflowId: 539, queueId: 686 },
    { workflowId: 526, queueId: 947 },
    { workflowId: 526, queueId: 581 },
  ]
};
  companyCode: string= '';
  constructor(
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly workflowService: WorkflowService,
    private readonly commonService: CommonService,
    private readonly globalVariable: GlobalService,
    private readonly retrievalService: RetrievalService,
    private readonly documentViewerServices: DocumentViewerService,
    private readonly dialog: MatDialog,
    private readonly dateAdapter: DateAdapter<any>,
    private readonly fb: FormBuilder,
    private readonly cdr: ChangeDetectorRef,
    private readonly dateService: DateService
  ) {
    const paramsObj = this.getRouteParams();
    if (!this.validateParams(paramsObj)) {
      window.close();
    } else {
      this.assignParams(paramsObj);
      this.source = Object.keys(this.workFlowViewEmitter).find(k => this.workFlowViewEmitter[k as keyof typeof this.workFlowViewEmitter] === this.pPageType) ?? '';
    }
  }
  ngOnInit() {
    this.commonService.clearMessage();
    this.selectedSystemId = this.globalVariable.getSelectedSystemId;
    if(!this.selectedSystemId){
      this.isLoading = false;
    }
    this.userGPID = this.globalVariable.getUserGPID;
    AppContext.userDetails = this.globalVariable.getUserDetails;
    this.isAdmin = this.globalVariable.getIsFullAccess;
    this.isApprover = this.globalVariable.getIsApprover || this.globalVariable.getIsApproverVCSubAccess || this.globalVariable.getIsApproverSubstitutionAccess || this.globalVariable.getIsWorkflowApproverVCSubAccess;
    this.isWorkflowRetrievalApproverOnly = this.globalVariable.getIsWorkflowRetrievalApproverOnly;
    this.isWorkflowRetrievalVendorClassificationRoleAccess = this.globalVariable.getIsWorkflowRetrievalVendorClassificationAccess;
    this.isWorkflowRetrievalRoleAccess = this.globalVariable.getIsWorkflowRetrievalAccess;
    this.AdvanceInitiator = this.globalVariable.getAdvanceInititor;
    if (sessionStorage.getItem("selDocTypeName") !== null && sessionStorage.getItem("selDocTypeName") !== undefined && sessionStorage.getItem("selDocTypeName") !== "undefined") {
      this.nextDocType = sessionStorage.getItem("selDocTypeName");
    }
    this.authService.saveUserInfo();
    this.isRetrieval = this.source == "RETRIEVAL" ? true : false;
    if (this.isRetrieval) {
      this.documentNotesMenu = "View / Add Document Notes";
      this.workFlowNotesMenu = "View Workflow Notes";
    } else {
      this.documentNotesMenu = "View Document Notes";
      this.workFlowNotesMenu = "View / Add Workflow Notes";
    }
    this.getUserPreferences();
  }

  getUserDropDownDetails(): void {
    this.commonService.getReAssignUsers(
      this.globalVariable.getUserGPID,
      this.globalVariable.getSelectedSystemId
    ).subscribe((response) => {
      this.gpids = response.map((item: any) => ({
        value: item.emailId,
        name: item.fullName
      }));

      this.userFilteredOptionsMap = {};

      this.fieldArray.controls.forEach((field, index) => {
        if (field.value.controlName === 'USER_AUTOCOMPLETE') {
          const ctrl = field.get('valueAsString');
          if (ctrl) {
            this.userFilteredOptionsMap[index] = ctrl.valueChanges.pipe(
              startWith(ctrl.value || ''),
              map((input: string) => this._userFilter(input))
            );
          }
        }
      });
    });
  }

  private _userFilter(value: string): GPID[] {
    const filterValue = value.toLowerCase();
    return this.gpids.filter(
      (option) =>
        option?.name?.toLowerCase().includes(filterValue) ||
        option?.value?.toLowerCase().includes(filterValue)
    );
  }

  onGlEntriesCountChanged(count: number): void {
    this.totalGlEntries = count;
  }

  isNodeExpanded(node: BatchNode): boolean {
    return this.expandedNodeIds.has(String(node.value));
  }

  toggleNode(node: BatchNode): void {
    const nodeId = String(node.value);
    if (this.expandedNodeIds.has(nodeId)) {
      this.expandedNodeIds.delete(nodeId);
    } else {
      this.expandedNodeIds.add(nodeId);
    }
  }

  getUserPreferences() {
      this.commonService.getUserPerferences().subscribe({
        next: (response: UserSystemPreference[]) => {
          this.userSystemPreferencedata = response;
          this.globalVariable.setUserPreferences = response;
          this.userPreferenceSet();
          this.getWorkItemDetails();
        },
        error: (error) => {
          this.getWorkItemDetails();
          this.commonService.showMessage("Error while retrieving the system preference", 'error');
        }
      });
  }

  userPreferenceSet(): void {
    this.userSystemPreferencedata.forEach((element) => {
      if (element.preferenceTitle == "Timezone") {
        this.selectedPreferenceValue = element.preferenceValue;
      }
      else if (element.preferenceTitle == "Routing in Workflow") {
        if (element.preferenceValue == "true") {
          this.isRoutingButton = true;
          localStorage.setItem("setUserPerferenceRoutingButton", "button");
        } else {
          this.isRoutingButton = false;
          localStorage.setItem("setUserPerferenceRoutingButton", "select");
        }
      }
    });
  }

  isGLEntryEditable(systemId: number, itemData: { workflowId: number; queueId: number }): boolean {
    const rulesForSystem = this.editableGLEntryRules[systemId];
    if (!rulesForSystem) {
      return false; // If no rules for the systemId, return false
    }
    return rulesForSystem.some(rule =>
      rule.workflowId === itemData.workflowId && rule.queueId === itemData.queueId
    );
  }

  getWorkItemDetails() {
    if (!this.isRetrieval) {
      this.isRoutingBtnLoading = true;
      this.documentViewerServices.getWorkItemDetails(this.userGPID, this.selectedSystemId, this.pInstanceId).subscribe({
        next: (response: WorkItemResponseDto) => {
          if (response) {
            this.processWorkItemResponse(response);
          }
        },
        error: (error) => {
          this.isRoutingBtnLoading = true;
        }
      });
    }
    else {
      if (this.isWorkflowPoBtach()) {
        this.showBatchContent(0, this.pBatchId);
      }
      else {
        this.documentTypeId = 0;
        this.loadPage(this.pDocId, this.pStorageRepoId);
      }
    }
  }

  processWorkItemResponse(itemData: WorkItemResponseDto): void {
    this.routingButtons = itemData.transitionRules;
    this.resetRoutingButtons = this.routingButtons;
    this.setRoutingButtons = this.routingButtons;
    this.isRoutingBtnLoading = false;
    this.canReturn = itemData.canReturn;
    this.previousQueueName = itemData.previousQueueName.toLowerCase();
    this.QueueId = itemData.queueId;
    this.previousQueueId = itemData.previousQueueId;
    this.workFlowID = itemData.workflowId;
    this.owningUser = itemData.owningUserGpid;
    this.referenceType = itemData.referenceType;
    this.documentTypeId = itemData.documentTypeId;
    this.documentTypeIdForGL = itemData.documentTypeId;
    this.fromQueue = itemData.queueName;
    this.sendautoEmail = this.fromQueue.indexOf('RTV') !== -1 && this.fromQueue.indexOf('Hold') === -1;
    this.WITitle = itemData.title;
    this.documentTypeForQueue = itemData.nextWorkitemComboValues;
    this.selDocumentType = "";
    this.isEditableGLEntryTable = (['WORKFLOW', 'MY_WORKITEMS_BASKET'].includes(this.source)) && this.isGLEntryEditable(this.selectedSystemId, itemData);
    this.isWIInCustOrNonPOApprovalQueues = [4, 14, 12, 20, 173, 175, 184, 186, 397, 403, 407, 532, 536, 545, 549, 558, 562, 552, 539, 526].includes(itemData.workflowId);
    this.isCustGLEntryTableDisplay = itemData.workflowId === 12 || itemData.workflowId === 20 || itemData.workflowId === 397 || itemData.workflowId === 552 || itemData.workflowId === 539 || itemData.workflowId === 526;
    if (itemData.workflowId === 12) {
        this.isCustWorkFlowBaName = 'RS';
    } else if (itemData.workflowId === 20) {
        this.isCustWorkFlowBaName = 'BA';
    } else {
        this.isCustWorkFlowBaName = "";
    }
    // Set "Is Coding Changed" to "Yes" for NWE Waiting for Approver 1 queues when a GL Entry is added or updated.
    this.isCodingFieldUpdateRequired = [507, 470, 413, 878, 841, 770, 733, 662, 947, 625].includes(itemData.queueId);

    this.selectNextDocType();
    
    this.wiLockedInfoAsString = itemData.wiLockedInfoAsString;
    if (itemData.wiLockedInfo == 1) {
      this.isWorkItemAvailable();
    }

    this.isEmailToRequestorMenu = itemData.emailToRequestor;

    if (!this.isRetrieval) {
      this.assignWorkItem();
    }

    if (this.copyQueueIds.indexOf(Number(this.pQueueId)) !== -1) {
      this.isCopyEnabled = true;
    }
    
    if (this.isWorkflowPoBtach()) {
      this.showBatchContent(0, this.pBatchId);
    } else {
      this.documentTypeId = 0;
      this.loadPage(this.pDocId, this.pStorageRepoId, this.pBatchId);
    }
  }

  private selectNextDocType(): void {
    if (this.nextDocType === 'All') {
      this.selDocumentType = 'all';
      return;
    }
    for (const obj of this.documentTypeForQueue) {
      if (this.nextDocType && obj.name.includes(this.nextDocType)) {
        this.selDocumentType = JSON.stringify(obj);
        break;
      }
    }
  }

  loadPage(documentId: string, storageRepoId: string, batch?: string) {
    this.selectedNodeValue = documentId;
    this.currentStorageRepoId = storageRepoId;
    if (this.isWorkflowPoBtach()) {
      this.isViewerEnabledDefault = true;
      this.selectedDocumentId = documentId;
    }

    this.isSelectResultsLoading = true;
    this.isSelectResultsAvailable = false;
    this.isBatchSelected = false;
    this.initalLoad = false;
    this.selectedDocumentId = documentId;
    if (!this.isRetrieval) {
      this.isReadOnly = !AppContext.userDetails.canEditWorkflow;
    } else {
      this.isReadOnly = !AppContext.userDetails.canEditRetrieval;
    }
    //To check the user is from the Mywork basket or workflow
    if (this.AdvanceInitiator && this.pPageType == "001") {
      this.isReadOnly = false;
      this.isAdvanceInitiatorAsApprover = true;
    } else if (this.AdvanceInitiator && this.pPageType == "002") {
      this.isAdvanceInitiatorAsApprover = false;
      this.isReadOnly = true;
    }

    if (!this.documentTypeId) {
      this.documentTypeId = 0;
    }
    this.getIndexFieldValues();
    if (batch == "email") {
      this.processmailData();
    }
    if (batch == this.pBatchId) {
      this.isSendDocRecycleEnabled = true;
      this.isSendNewBatchEnabled = true;
    } else {
      this.isSendDocRecycleEnabled = false;
      this.isSendNewBatchEnabled = false;
    }
    this.loadDocuments();
  }

  processmailData() {
    this.missingFields = false;
    this.extractMailFieldsFromSelectResults();
    const messages = this.buildMailFieldValidationMessages();
    if (messages.length) {
      this.missingFields = true;
      this.errorModalPopUp('Missing fields', 'Please fill mandatory fields\n' + messages.join('\n'));
      return;
    }

    this.DocumentType = (this.DocumentType || '').substring(0, 2).trim();
    this.RTVReasonCode = (this.RTVReasonCode || '').substring(0, 2).trim();
    this.getVendorEmailDetails();
  }

  private extractMailFieldsFromSelectResults(): void {
    this.selectResults.forEach((obj) => {
      const name = obj.displayName;
      const value = obj.valueAsString;
      switch (name) {
        case 'RTV Contact Email Address':
        case 'RTV Contact Email':
          this.RTVContactEmailId = value;
          break;
        case 'Vendor Invoice Number':
          this.InvoiceNumber = value;
          break;
        case 'RTV Other Description':
          this.RTVOtherDescription = value;
          break;
        case 'Supplier Country':
          this.supplierCountry = value;
          break;
        case 'Document Type':
          this.DocumentType = value;
          break;
        case 'Vendor ID':
          this.VendorId = value;
          break;
        case 'Company Code Id':
        case 'Company Code ID':
          this.CompanyCodeID = value;
          break;
        case 'RTV Reason Code':
          this.RTVReasonCode = value;
          break;
        default:
          break;
      }
    });
  }

  private buildMailFieldValidationMessages(): string[] {
    const messages: string[] = [];

    if (!this.RTVContactEmailId) {
      messages.push('* RTV Contact Email');
    } else {
      const reg = /^\w+([-.+']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
      if (!reg.test(this.RTVContactEmailId)) {
        messages.push('* E-mail address is not valid');
      }
    }

    if (!this.InvoiceNumber) messages.push('* Vendor Invoice Number');
    if (!this.supplierCountry) messages.push('* Supplier Country');
    if (!this.VendorId) messages.push('* Vendor ID');
    if (!this.CompanyCodeID) messages.push('* Company Code ID');

    if (!this.RTVReasonCode) {
      messages.push('* RTV Reason Code');
    } else {
      const code = (this.RTVReasonCode || '').substring(0, 2).trim();
      if (code === '17' && !this.RTVOtherDescription) {
        messages.push('* RTV Other Description');
      }
    }

    return messages;
  }

  getVendorEmailDetails(): void {
    this.documentViewerServices.getVendorEmailDetails(this.userGPID, this.selectedSystemId,
      this.DocumentType, this.RTVReasonCode, this.CompanyCodeID, this.VendorId)
      .subscribe({
        next: (response: VendorEmailDto[]) => {
          this.vendorMailResponse = response[0];
          if (!this.vendorMailResponse) {
            this.errorModalPopUp('Vendor email response message', "No Email Template found");
          } else if (
            !this.vendorMailResponse.email1 ||
            this.vendorMailResponse.email1 == " " ||
            !this.vendorMailResponse.reasonDescription ||
            this.vendorMailResponse.reasonDescription == " " ||
            !this.vendorMailResponse.contactNumber ||
            this.vendorMailResponse.contactNumber == " " ||
            !this.vendorMailResponse.country ||
            this.vendorMailResponse.country == " "
          ) {
            this.errorModalPopUp('Vendor email response message', "No Email Template found");
          } else {
            this.sendRTOEmail();
          }
        },
        error: (error) => {
        }
      });
  }

  sendRTOEmail() {
    const requestObj: any = {};
    requestObj.UserGPID = this.userGPID;
    requestObj.SystemId = this.selectedSystemId;
    requestObj.FromAddress = this.vendorMailResponse?.email2;
    requestObj.ToAddress = this.RTVContactEmailId;
    requestObj.bccAddress = this.vendorMailResponse?.bcc;

    let tempSubject = this.vendorMailResponse?.emailSubject.replaceAll(
      '<invoice number>',
      this.InvoiceNumber
    );
    requestObj.Subject = tempSubject;

    let temp = this.vendorMailResponse?.emailFormat;
    let temp1 = temp?.replaceAll('<invoice number>', this.InvoiceNumber);

    let temp2: string | undefined = '';
    const reasonDesc = this.vendorMailResponse?.reasonDescription;
    const isReasonSplit = reasonDesc?.indexOf('@');

    if (isReasonSplit !== -1) {
      const reasonMainAlt = reasonDesc?.split('@');
      if (this.RTVReasonCode == '17') {
        temp2 = temp1?.replaceAll('<Reason>', `${reasonMainAlt![0]} ${this.RTVOtherDescription}`)
          .replaceAll('<Reason1>', `${reasonMainAlt![1]} ${this.RTVOtherDescription}`);
      } else {
        temp2 = temp1?.replaceAll('<Reason>', reasonMainAlt![0])
          .replaceAll('<Reason1>', reasonMainAlt![1]);
      }
    } else {
      const fullReason =
        this.RTVReasonCode === '17'
          ? `${reasonDesc} ${this.RTVOtherDescription}`
          : reasonDesc;
      temp2 = temp1?.replaceAll("<Reason>", String(fullReason)).
        replaceAll('<Reason1>', String(fullReason));
    }

    let tempFinal = temp2?.replaceAll('<Emailbody>', this.vendorMailResponse!.emailBody)
      .replaceAll('<Emailbody1>', this.vendorMailResponse!.emailBody1)
      .replaceAll('<email 1>', this.vendorMailResponse!.email1)
      .replaceAll('<email 2>', this.vendorMailResponse!.email2)
      .replaceAll('<phone 1>', this.vendorMailResponse!.contactNumber)
      .replaceAll('<country>', this.vendorMailResponse!.country)
      .replaceAll('<VAT Code List>', this.vendorMailResponse!.vat)
      .replaceAll('<Footer>', this.vendorMailResponse!.emailFooter)
      .replaceAll('<Footer1>', this.vendorMailResponse!.emailFooter1);

    requestObj.Message = tempFinal;
    const items = {
      Id: this.pDocId,
      Type: 'document'
    };
    this.sendautoEmails(requestObj, items);
  }

  sendautoEmails(request: any, item: any): void {
    this.commonService.sendAutoEmail(request, item).subscribe({
      next: (response) => {
        const dialogData: DialogData = {
          title: '',
          message: "E-mail sent successfully",
          showFinishButton: true,
          showCancelButton: true,
        };
        const dialogRef = this.dialog.open(DialogComponent, {
          data: dialogData,
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result === 'finish') {
            this.finishRTVMail();
          }
        });
      },
      error: (error) => {
        this.commonService.showMessage("Error in sending Email.", "error");
      }
    });
  }

  finishRTVMail(): void {
    const finishWorkmail = this.routingButtons.find(obj => obj.toQueueName == 'Finish');
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = this.padZero(today.getMonth() + 1);
    const dd = this.padZero(today.getDate());
    const hr = this.padZero(today.getHours());
    const mi = this.padZero(today.getMinutes());
    const ss = this.padZero(today.getSeconds());
    let rtvEmailSentDate = `${yyyy}-${mm}-${dd} ${hr}:${mi}:${ss}`;
    this.selectResults.forEach((value, key) => {
      if (value.columnName == "RTV_EMAIL_SENT_DATE") {
        value.valueAsString = rtvEmailSentDate;
      }
      if (value.columnName == "RTV_EMAIL_SENT") {
        value.valueAsString = 'true';
      }
    });
    this.getSearchBoxVal = true;
    this.saveWorkItem();
    if (finishWorkmail) {
      this.MoveWorkItemMail(finishWorkmail);
    }
  }

  saveWorkItem() {
    this.error = false;
    this.getSearchBoxValues();
    this.commonService.showMessage("Saving indexing fields", 'success');
    this.proceedToSaveWorkItem();
  }

  proceedToSaveWorkItem() {
    this.saveWorkItemCall();
  }

  saveWorkItemCall() {
    let saveIndexFields = this.prepareIndexingFieldsToSave();
    this.documentViewerServices.saveWorkItem(this.userGPID, this.selectedSystemId, saveIndexFields, this.isRetrieval, this.pDocId)
      .subscribe({
        next: (response: any) => {
          if (response) {
            this.commonService.showMessage("Saved the details successfully.", 'success');
          } else {
            this.commonService.showMessage("Error while saving data.", 'error');
          }
        },
        error: (error: any) => {
          this.errorModalPopUp("ERROR", error.error.message);
          this.commonService.showMessage("Error while saving data.", 'error');
        }
      });
  }

  getSearchBoxValues() {
    this.documentIndexFieldValues = this.fieldArray.getRawValue();
  }

  MoveWorkItemMail(finishWorkmail: TransitionRules) {
    //it's not defined in amesa tooo
  }

  padZero(value: number): string {
    return value < 10 ? `0${value}` : value.toString();
  }

  errorModalPopUp(title: string, message: string, isLockMessage: boolean = false): void {
    const dialogData: DialogData = {
      title: title,
      message: message,
      showCancelButton: isLockMessage ? false : true,
      showButtons: false
    };
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '600px',
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (isLockMessage && AppContext.userDetails.highestSecurityTypeName != "FullAccess") {
        window.close();
      }
    });
  }

  processResponsedata(servcieresponse?: [IndexFields[], DocInfo[]]) {
    this.isSelectResultsLoading = false;
    this.isSelectResultsAvailable = true;
    this.error = false;
    this.documentIndexFieldValues.forEach((obj: any, index: any) => {
      if (obj.FnPropertyName == "PurchaseOrderPONumber") {
        this.getPoNumber = obj.valueAsString;
        this.isPoNumberEmpty(this.getPoNumber);
      }
      if (obj.controlName == "AUTO_COMPLETE") {
        obj.autocomOptions = [];
        obj.comboValues.forEach((item: IndexFields) => {
          obj.autocomOptions.push(item.comboValues);
        });
      }

      // modifing text-area 
      if (this.isTextareaField(obj.columnName)) {
        obj.controlName = 'TEXT_AREA';
      }

      if (obj.displayName?.includes('Approver') && obj.displayName?.includes('Email Address')) {
        obj.controlName = 'USER_AUTOCOMPLETE';
      }

      if (obj.controlName == "CHECK_BOX") {
        if (obj.valueAsString == "1" || obj.valueAsString == "true") {
          obj.valueAsString = true;
        } else {
          obj.valueAsString = false;
        }
      }

      //Populating approved amount for all type user
      if (environment.WaitingForApprovalQueueIds.includes(this.pQueueId) && (obj.columnName == "APPROVED_AMOUNT" && (obj.valueAsString === null || obj.valueAsString.length === 0))) {
        obj.valueAsString = this.documentIndexFieldValues.find(s => s.columnName == "TOTAL")?.valueAsString;
      }

      this.mappedCompanyCode = this.documentIndexFieldValues.find(s => s.columnName == "COMPANY_CODE")?.valueAsString ?? "";
      this.isLoading = false;
    });
  }

  isTextareaField(colName: string): boolean {
    const systemContainsRFR = [8003, 8006, 8007];
    const chinaIndexFieldsTextArea = ["ERROR_REPORT", "INVOICES_IN_SAME_BATCH"];
    return (
      colName.includes('COMMENT') ||
      (this.selectedSystemId === 8004 && colName === "EXCEPTION_MESSAGE") ||
      (systemContainsRFR.includes(this.selectedSystemId) && colName === "REASON_FOR_RETURN") ||
      (this.selectedSystemId === 8005 && chinaIndexFieldsTextArea.includes(colName))
    );
  }

  isPoNumberEmpty(val: any) {
    if (val == "" || val == null) {
      this.isViewMasterBatchEnabled = false;
    } else {
      this.isViewMasterBatchEnabled = true;
    }
    this.validatePoNumber(this.getPoNumber);
  }

  validatePoNumber(val: any): boolean {
    this.isPoNumberError = isNaN(val);
    return this.isPoNumberError;
  }

  validateEmailRequestor(val: any): boolean {
    if (isNaN(val)) {
      this.isEmailRequestorError = true;
      return this.isEmailRequestorError;
    } else {
      this.isEmailRequestorError = false;
      return this.isEmailRequestorError;
    }
  }

  saveDocHistory(documentId: string, action: string, comments: string) {
    let saveDocHistoryDto: SaveDocHistoryDto = {
      userGpid: this.userGPID,
      systemId: this.selectedSystemId,
      action: action,
      documentId: documentId,
      comments: comments,
      createdDate: null,
      fieldName: null,
      newValue: null,
      oldValue: null
    }
    this.documentViewerServices.saveDocHistory(saveDocHistoryDto).subscribe({
      next: (response) => {
      },
      error: (error) => {
      }
    });
  }

  showBatchContent(index: number, batch: string) {
    this.batchLoading = true;
    this.selectedIndex = -1;
    this.isSendDocRecycleEnabled = false;
    this.isSendNewBatchEnabled = false;

    if (this.selectedBatchIndex != index) {
      this.selectedBatchIndex = index;
      this.documentViewerServices.getBatchHierarchyInfo(this.userGPID, this.selectedSystemId, this.pBatchId)
        .subscribe({
          next: (response) => {
            this.batchHierarchyInfo = response;
            if (this.batchHierarchyInfo.length > 0) {
              this.documentProperties = response[0].Properties;
              this.batchLoading = false;
            } else {
              this.isDocumentsNotAvailable = true;
              this.getPoNumber = "";
              this.isPoNumberEmpty(this.getPoNumber);
            }
            this.cdr.detectChanges();
          },
          error: (error) => {
            this.isDocumentsNotAvailable = true;
            this.batchLoading = false;
          }
        });
    } else {
      this.selectedBatchIndex = -1;
      this.batchLoading = false;
    }
    this.updateCopyLink();
  }

  updateCopyLink() {
    if (this.isBatchSelected || this.initalLoad) {
      this.documentViewerServices.getDocumentLink(this.userGPID, this.selectedSystemId, this.pBatchId, "batch").subscribe({
        next: (response) => { this.link = response; },
        error: (error) => { }
      });
    } else {
      this.documentViewerServices.getDocumentLink(this.userGPID, this.selectedSystemId, this.pDocId, "document").subscribe({
        next: (response) => { this.link = response; },
        error: (error) => { }
      });
    }
  }

  isWorkflowPoBtach() {
    return this.referenceType?.toLocaleLowerCase() == "po batch";
  };

  getIndexFieldValues() {
    this.isIndexFieldsLoading = true;
    this.documentViewerServices.getSelectFields(this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId, this.pDocId).subscribe({
      next: (response: IndexFields[]) => {
        this.documentIndexFieldValues = response;
        this.abbyyBatchId = this.getValueByColumnName('ABBYY_BATCHID');
        this.docId = this.getValueByColumnName('DOCUMENT_ID');
        this.abbyyDocId = this.getValueByColumnName('ABBYY_DOCID');
        this.vendorerpId = this.getValueByColumnName('VENDOR_CODE') ?? '';
        this.companyCode = this.getValueByColumnName('COMPANY_CODE') ?? '';
        if (this.vendorerpId && this.companyCode && this.isEditableGLEntryTable && (this.workFlowID == 14 || this.workFlowID == 4)) {
          this.commonService.getVendorClassifications(this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId, this.vendorerpId, this.companyCode, 0).subscribe({
            next: (response) => {
              const vendorData = response?.results?.[0];
              this.isVendorIntercompany = (vendorData?.interCompany === '1');
            },
            error: (error) => {
              this.commonService.showMessage('Error loading Vendor details: ' + error.error.message, 'error');
            }
          });
        }
        this.prepareIndexingFields();
        this.initForm(response);
        this.getUserDropDownDetails();
        this.isIndexFieldsLoading = false;
      },
      error: () => {
        this.isIndexFieldsLoading = true;
      }
    })
  }

  getValueByColumnName(columnName: string): string | undefined {
    const found = this.documentIndexFieldValues.find(
      (item) => item.columnName === columnName
    );
    return found ? found.valueAsString : undefined;
  }

  prepareIndexingFields(): void {
    this.makeFieldVerified();
    this.processResponsedata();
  }

  makeFieldVerified(): void {
    this.documentIndexFieldValues.forEach(value => {
      this.setApproverReadOnly(value);
      this.setOtherRolesReadOnly(value);
      this.setCustomerQueuesReadOnly(value);
      if (!this.isRetrieval && ['ON_HOLD', 'HOLD_REASON'].includes(value.columnName)) {
        value.isReadOnly = false;
      }
    });
  }

  private setApproverReadOnly(value: IndexFields): void {

    if (!this.isApprover && !this.isAdvanceInitiatorAsApprover) {
      return;
    }

    const approverQueueMap: Record<string, number[]> = {
      COMMENTS1: [131, 90, 69, 31, 199, 233, 291, 325, 470, 507, 413, 625, 662, 733, 770, 841, 878],  // Waiting for Approver 1 queues
      COMMENTS2: [133, 91, 71, 32, 200, 234, 292, 326, 471, 492, 426, 626, 647, 734, 755, 842, 863],  // Waiting for Approver 2 queues
      COMMENTS3: [135, 92, 73, 33, 201, 235, 293, 327, 472, 493, 423, 627, 648, 735, 756, 843, 864],  // Waiting for Approver 3 queues
      COMMENTS4: [137, 93, 75, 34, 202, 236, 294, 328, 459, 494, 421, 614, 649, 722, 757, 830, 865],  // Waiting for Approver 4 queues
      COMMENTS5: [139, 94, 77, 35, 203, 237, 295, 329, 462, 495, 419, 617, 650, 725, 758, 833, 866],  // Waiting for Approver 5 queues
    };

    const alwaysEditableColumns = ["PERIOD", "DESCRIPTION", "APPROVED_AMOUNT", "PO_NUMBER", "DELIVERY_NOTE_NO"];

    // check if any of COMMENTS1–COMMENTS5 is enabled
    const approverComments = ["COMMENTS1", "COMMENTS2", "COMMENTS3", "COMMENTS4", "COMMENTS5"];

    // NonPO Approval Assignment queues where approver email must be editable
    const approverEmailEditableQueues = [29, 88, 197, 231, 289, 323, 468, 505, 623, 660, 731, 768, 839, 867];

    const queueIdToCommentMap: Record<number, string> = {};

    Object.entries(approverQueueMap).forEach(([comment, queueIds]) => {
      queueIds.forEach(queueId => {
        queueIdToCommentMap[queueId] = comment;
      });
    });

    const editableCommentColumn = queueIdToCommentMap[Number(this.pQueueId)];

    let isEditable = alwaysEditableColumns.includes(value.columnName) || value.columnName === editableCommentColumn;

    const isAnyApproverCommentEnabled = approverComments.includes(editableCommentColumn);

    if (value.columnName === 'COMMENTS') {
      isEditable = !isAnyApproverCommentEnabled;
    }

    if (value.columnName === 'APPROVER_EMAIL' && approverEmailEditableQueues.includes(Number(this.pQueueId))) {
      isEditable = true;
    }

    value.isReadOnly = !isEditable;
  }

  private setOtherRolesReadOnly(value: IndexFields): void {
    const columnName = value.columnName;

    if (this.isWorkflowRetrievalApproverOnly) {
      if (['80', '143'].includes(this.pQueueId)) {
        if (['COMMENTS', 'REBATE_AGREEMENT'].includes(columnName)) {
          value.isReadOnly = false;
        } else {
          value.isReadOnly = true;
        }
      } else {
        const editableApproverColumns = ['APPROVER_EMAIL', 'APPROVER2_EMAIL', 'APPROVER3_EMAIL', 'APPROVER4_EMAIL', 'APPROVER5_EMAIL', 'COMMENTS'];
        const isAdditionalEditableColumn = ['68', '130'].includes(this.pQueueId) && ['PERIOD', 'DESCRIPTION'].includes(columnName);

        if (editableApproverColumns.includes(columnName) || isAdditionalEditableColumn) {
          value.isReadOnly = false;
        } else {
          value.isReadOnly = true;
        }
      }
    }
  }

  private setCustomerQueuesReadOnly(value: IndexFields): void {

    // Restrict editable fields in Iberia ES/PT and NE BE/DE/NL/FR - Customer NonPO Approval Workflow queues.
    if ((this.isWorkflowRetrievalVendorClassificationRoleAccess || this.isWorkflowRetrievalRoleAccess) && [381, 382, 397, 526, 539, 552].includes(this.workFlowID)) {
      const editableWorkflowColumns = ['DESCRIPTION', 'PERIOD', 'SECTION', 'SAP_FI_DOCNO', 'FI_DOC_YEAR', 'COMMENTS', 'PO_NUMBER'];

      if (editableWorkflowColumns.includes(value.columnName)) {
        value.isReadOnly = false;
      } else {
        value.isReadOnly = true;
      }
    }

    //Restrict REBATE_AGREEMENT field to read-only for all queues except 566-576 - 11 Customer queues in DE Customer NonPO Approval Workflow.
    const customerDEQueues = ['566', '567', '568', '569', '570', '571', '572', '573', '574', '575', '576'];

    if ((this.isWorkflowRetrievalRoleAccess || this.isWorkflowRetrievalApproverOnly) && customerDEQueues.includes(this.pQueueId) && value.columnName === 'REBATE_AGREEMENT') {
      value.isReadOnly = false;
    }

    // Restrict CN_REQUEST_NUMBER field to read-only for Billing Team and Sales Finance queues - DE Customer NonPO Approval Workflow.
    if (this.isWorkflowRetrievalRoleAccess && ['578', '577'].includes(this.pQueueId) && value.columnName === 'CN_REQUEST_NUMBER') {
      value.isReadOnly = true;
    }

    // Allow editing of CASE_ID field for Billing Team queue - DE Customer NonPO Approval Workflow.
    if ((this.isWorkflowRetrievalRoleAccess || this.isWorkflowRetrievalApproverOnly) && this.pQueueId == '578' && value.columnName === 'CASE_ID') {
      value.isReadOnly = false;
    }
  }

  getMomentFormat(field: IndexFields): string {
    let rawFormat = field.fieldDateFormat?.defaultFormat || 'dd/MM/yyyy HH:mm:ss';
    rawFormat = this.dateService.cleanFormat(rawFormat);
    return this.dateService.toMomentFormat(rawFormat);
  }
  
  formatDate(date: Date, field: IndexFields): string {
    const momentFormat = this.getMomentFormat(field);
    return moment(date).format(momentFormat);
  }


  onDateChange(event: any): void {
    const selectedDate: Date = event.value;
    if (!selectedDate) return;
  }

  onDatepickerOpened(index: number): void {
    const field = this.fieldArray.at(index).value;
    let rawFormat = field.fieldDateFormat?.defaultFormat;
    const culture = field.fieldDateFormat?.cultureName;
    if (!rawFormat) return;
    rawFormat = this.dateService.cleanFormat(rawFormat);
    const momentFormat = this.dateService.toMomentFormat(rawFormat);
    if (this.dateAdapter instanceof DynamicDateAdapter) {
      this.dateAdapter.setDynamicFormat(momentFormat);
      this.dateAdapter.setDynamicLocale(culture);
    }
  }

  getDatePlaceholder(index: number): string {
    const format = this.fieldArray.at(index).value.fieldDateFormat?.defaultFormat;
    return format?.split(' ')[0] || 'DD/MM/YYYY';
  }
 
  parseDateValue(valueAsString: string, format: string): Date | null {
    if (!valueAsString || !format) return null;
    const momentFormat = this.dateService.toMomentFormat(this.dateService.cleanFormat(format));
    const parsed = moment(valueAsString, momentFormat, true);
    return parsed.isValid() ? parsed.toDate() : null;
  }


  initForm(fields: IndexFields[]) {
    fields = fields.sort((a, b) => a.fieldOrder - b.fieldOrder);

    const formGroups = fields.map(field => {
      const validators = this.getFieldValidators(field);
      const { controlValue, timeValue } = this.getFieldValue(field);

      return this.fb.group({
        columnName: [field.columnName],
        id: [field.id],
        displayName: [field.displayName],
        docTypeId: [field.docTypeId],
        docTypeName: [field.docTypeName],
        controlType: [field.controlType],
        fieldLength: [field.fieldLength],
        fieldOrder: [field.fieldOrder],
        isMandatory: [field.isMandatory],
        allowMultiples: [field.allowMultiples],
        useLastIndexingValue: [field.useLastIndexingValue],
        showInInbox: [field.showInInbox],
        preIndexValue: [field.preIndexValue],
        mask: [field.mask],
        toolTip: [field.toolTip],
        dataSource: [field.dataSource],
        fieldDataType: [field.fieldDataType],
        controlName: [field.controlName],
        valueAsString: [
          {
            value: controlValue ?? '',
            disabled: (
              this.isApprover ||
              this.isAdvanceInitiatorAsApprover ||
              this.isWorkflowRetrievalApproverOnly ||
              this.isWorkflowRetrievalVendorClassificationRoleAccess ||
              this.isWorkflowRetrievalRoleAccess
            )
              ? field.isReadOnly
              : this.isReadOnly
          },
          validators
        ],
        timeValue: [timeValue],
        comboValues: [field.comboValues],
        fieldDateFormat: this.fb.group({
          cultureName: [field.fieldDateFormat?.cultureName],
          language: [field.fieldDateFormat?.language],
          defaultFormat: [field.fieldDateFormat?.defaultFormat]
        }),
        requiresVerification: [field.requiresVerification],
        isValidationFailed: [field.isValidationFailed],
        isSystemField: [field.isSystemField],
        isAutoMap: [field.isAutoMap],
        isComboValueMapped: [field.isComboValueMapped],
        isComboOnDemand: [field.isComboOnDemand],
        vmdLookUpField: [field.vmdLookUpField],
        isVMDLookUpField: [field.isVMDLookUpField],
        isReadOnly: [
          (this.isApprover || this.isAdvanceInitiatorAsApprover)
            ? field.isReadOnly
            : this.isReadOnly
        ]
      });
    });

    this.indexForm = this.fb.group({
      fields: this.fb.array(formGroups)
    });
  }

  private getFieldValidators(field: IndexFields): any[] {
    const validators = [];

    if (field.isMandatory) {
      validators.push(Validators.required);
    }

    if (field.controlName !== 'TEXT_BOX') {
      return validators;
    }

    const fieldLength = field.fieldLength;

    if (fieldLength && typeof fieldLength === 'string' && fieldLength.includes(',')) {
      const [maxTotal, maxDecimal] = fieldLength.split(',').map(value => parseInt(value.trim()));

      if (!isNaN(maxTotal) && !isNaN(maxDecimal)) {
        validators.push(this.totalAndDecimalLengthValidator(maxTotal, maxDecimal));
      }
    } else if (!isNaN(Number(fieldLength))) {
      validators.push(Validators.maxLength(Number(fieldLength)));
    }

    return validators;
  }

  private getFieldValue(field: IndexFields): { controlValue: any; timeValue: string | null } {
    let controlValue: any = field.valueAsString;
    let timeValue: string | null = null;

    if (field.controlName !== 'DATE') {
      return { controlValue, timeValue };
    }

    const rawFormat = this.dateService.cleanFormat(field.fieldDateFormat?.defaultFormat);
    const culture = field.fieldDateFormat?.cultureName;
    const momentFormat = this.dateService.toMomentFormat(rawFormat);

    if (this.dateAdapter instanceof DynamicDateAdapter) {
      this.dateAdapter.setDynamicFormat(momentFormat);
      this.dateAdapter.setDynamicLocale(culture);
    }

    let dateOnlyValue = field.valueAsString;

    if (dateOnlyValue) {
      const splitValue = dateOnlyValue.split(/[T\s]/);
      dateOnlyValue = splitValue[0];
      timeValue = splitValue[1] ?? '00:00:00';
    }

    controlValue = this.parseDateValue(dateOnlyValue, rawFormat);

    return { controlValue, timeValue };
  }

  totalAndDecimalLengthValidator(maxTotalLength: number, maxDecimals: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (!value) return null;
      const str = value.toString();

      // Total character length check
      if (str.length > maxTotalLength) {
        return { maxTotalLength: true };
      }
      const parts = str.split('.');
      const decimalPart = parts[1] || '';
      if (decimalPart.length > maxDecimals) {
        return { decimalTooLong: true };
      }
      return null;
    };
  }

  get fieldArray() {
    return this.indexForm.get('fields') as FormArray;
  }
 
  loadDocuments() {
    this.isAttachmentLoading = true;
    this.documentViewerServices.getDocumentsLinkInfo(this.globalVariable.getUserGPID, this.globalVariable.getSelectedSystemId, this.pDocId)
    .subscribe({
      next: (response: DocInfo[]) => {
        this.isAttachmentLoading = false;
        this.documentList = response;
        if(this.documentList.length > 0) {
          this.selectedDocument = this.documentList[0];
          this.updateDocumentSourceUrl();
          this.saveDocHistory(this.pDocId, "VIEW", this.documentList[0].fileName);
        }
      },
      error: (error: any) => {
        this.isAttachmentLoading = true;
      }
    });
  }

  updateDocumentSourceUrl() {
    const systemId = this.globalVariable.getSelectedSystemId;
    if (systemId && this.pDocId) {
      this.documentSourceUrl = `${environment.documentViewerUrl}${systemId}/${this.pDocId}/false/${this.selectedDocument?.imageId}`;
    } else {
      this.documentSourceUrl = '';
    }
  }

  updateIframe(doc: any) {
    this.selectedDocument = doc;
    this.ImageId = Number(this.selectedDocument?.imageId ?? 0);
    this.updateDocumentSourceUrl();
  }

  onDocumentKeydown(event: KeyboardEvent, doc: any): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.updateIframe(doc);
    }
  }

  onTreeNodeKeydown(event: KeyboardEvent, node: any): void {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.loadPage(node.value, node.imageId);
    }
  }

  isWorkItemAvailable() {
    this.errorModalPopUp("", this.wiLockedInfoAsString, true);
  }

  assignWorkItem() {
    const postObj = new ReAssignReleaseDto();
    const assignmentWorkItem = [];
    assignmentWorkItem.push(this.pInstanceId);
    postObj.systemId = this.selectedSystemId;
    postObj.userGpid = this.userGPID;
    postObj.workItemId = assignmentWorkItem;
    postObj.queueId = Number(this.pQueueId);
    postObj.workFlowId = this.workFlowID;
    postObj.owningUser = this.owningUser;
    postObj.assignUserGpid = AppContext.userDetails.userName;

    this.workflowService.assignReleaseWorkItem(postObj).subscribe({
      next: (response) => {
        this.AssignedUser = this.userGPID;
        localStorage.setItem("AssignedUser", JSON.stringify(this.AssignedUser));
        this.commonService.showMessage("The workitems has been assigned.", "success");
        this.LockWorkitem(this.owningUser);
      },
      error: (error) => {
        this.errorModalPopUp("Error while assigning work items.", error.error.message);
      }
    });
  }
  LockWorkitem(owningUser: string) {
    this.documentViewerServices.workItemLockUnLock(this.AssignedUser, this.selectedSystemId, owningUser, this.pInstanceId, 1)
    .subscribe({
      next: (response) => { },
      error: (error) => {
        this.commonService.showMessage(error.error.message, "error");
      }
    });
  }

  assignParams(params: any): void {
    this.pQueueId = params.queueId;
    this.pDocId = params.docId;
    this.pInstanceId = params.instanceId;
    this.pPageType = params.pageType;
    this.pBatchId = params.batchId;
    this.pStorageRepoId = params.storageRepoId;
  }

  getRouteParams(): any {
    const params = this.route.snapshot.paramMap;
    const queueId = params.get('queueId');
    const docId = params.get('docId');
    const instanceId = params.get('instanceId');
    const pageType = params.get('type');
    const batchId = params.get('batchId');
    const storageRepoId = params.get('storageRepoId');
    return {
      queueId,
      docId,
      instanceId,
      pageType,
      batchId,
      storageRepoId
    };
  }

  validateParams(params: any): boolean {
    const isAllDigits = (value: any): boolean => typeof value === 'string' && /^\d+$/.test(value);
    return (
      isAllDigits(params.queueId) &&
      isAllDigits(params.docId) &&
      isAllDigits(params.instanceId) &&
      isAllDigits(params.pageType) &&
      isAllDigits(params.batchId)
    );
  }

  moveWorkItem(item: TransitionRules | string) {
    if (!item) return;

    if (this.lineItemsGlEntryComponent?.isSaveEnabled) {
      this.pendingItemToProcess = item; 
      this.lineItemsGlEntryComponent.triggerSaveRow();
    } else {
      this.continueMoveWorkItem(item); 
    }
  }

  continueMoveWorkItem(item: TransitionRules | string) {
    if (item) {
      if (item != "-1" && typeof item !== 'string') {
        if (item.prompt == "(null)" || item.prompt == "") {
          this.proceedToMoveWorkItem(item);
        } else {
          const dialogData: DialogData = {
            title: 'Move WorkItem confirmation',
            message: item.prompt,
            showConfirmButton: true,
            showCancelButton: true,
          };
          const dialogRef = this.dialog.open(DialogComponent, {
            data: dialogData,
          });
          dialogRef.afterClosed().subscribe(result => {
            if (result === 'confirm') {
              this.proceedToMoveWorkItem(item);
            }
          });
        }
      } else {
        this.proceedToMoveWorkItem(item);
      }
    }
  }

  onGLEntrySaveCompleted() {
    this.isGLEntrySaved = true;
    if (this.pendingItemToProcess) {
      this.continueMoveWorkItem(this.pendingItemToProcess);
      this.pendingItemToProcess = null;
    } else if (this.isCodingFieldUpdateRequired) {
      this.saveWorkItem();
    }
  }

  proceedToMoveWorkItem(item: TransitionRules | string) {
    this.isLoading = true;
    const routeWorkItemRequest = new MoveWorkItemDto(); 
    this.getSearchBoxValues();
    if (item === '') return;

    this.prepareRoute(routeWorkItemRequest, item);

    if (typeof item !== 'string' && item.workflowNotes !== undefined) {
      routeWorkItemRequest.workitemNotes = item.workflowNotes;
      item.workflowNotes = '';  
    } else {
      routeWorkItemRequest.workitemNotes = '';
    } 

    this.getSearchBoxValues();

    const isValid = this.validateMandatoryFields(this.Queuedetails.FromQueueId, this.Queuedetails.ToQueueId);
    if (!isValid) {
      this.isLoading = false;
      return;
    }

    this.routeWorkItem(routeWorkItemRequest, item);
  }

  private prepareRoute(req: MoveWorkItemDto, item: TransitionRules  | string | undefined): void {
    const isReturn = item === '-1';
    if (!isReturn && item && typeof item !== 'string') {
      this.RTVQueueCheck = item.toQueueName.indexOf('RTV');
      req.workFlowAction = 12; 
      const matchedButton = this.routingButtons.find(rb => rb.id === item.id);
      if (!matchedButton) return;
      this.Queuedetails.WorkItemId = this.pInstanceId;
      this.Queuedetails.workFlowID = matchedButton.workflowId;
      this.Queuedetails.FromQueueId = matchedButton.fromQueueId;
      this.Queuedetails.ToQueueId = matchedButton.toQueueId;
      this.Queuedetails.QueueVerification = matchedButton.queueVerificationReqEntering;
      this.Queuedetails.TransitionRuleVerification = matchedButton.verificationRequired;
      this.Queuedetails.RetainForwardingUser = matchedButton.retainForwardingUser;
      this.Queuedetails.QueueType = matchedButton.queueType;
      this.Queuedetails.ToQueueName = matchedButton.toQueueName;

      if (this.reRoute) {
        this.resetRoutingButtons = [];
        this.setRoutingButtons = this.routingButtons;
      } else {
        this.resetRoutingButtons = this.routingButtons;
        this.setRoutingButtons = [];
      }
      this.reRoute = !this.reRoute;
      this.isReturnClicked = false;
    } else if (isReturn) {
      // Return action
      req.workFlowAction = 8;
      this.Queuedetails.WorkItemId = this.pInstanceId;
      this.Queuedetails.workFlowID = this.workFlowID;
      this.Queuedetails.FromQueueId = this.QueueId;
      this.Queuedetails.ToQueueId = this.previousQueueId;
      this.Queuedetails.QueueVerification = false;
      this.Queuedetails.TransitionRuleVerification = false;
      this.Queuedetails.RetainForwardingUser = false;
      this.Queuedetails.QueueType = 2;
      this.Queuedetails.ToQueueName = '';
      this.RTVQueueCheck = this.previousQueueName?.indexOf('rtv');
      this.isReturnClicked = true;
    }

    req.userGpid = this.userGPID;
    req.systemId = this.selectedSystemId;
    req.workItemId = this.Queuedetails.WorkItemId;
    req.workflowId = this.Queuedetails.workFlowID;
    req.fromQueueId = this.Queuedetails.FromQueueId;
    req.toQueueId = this.Queuedetails.ToQueueId;
    req.indexingFields = this.prepareIndexingFieldsToSave();
    req.queueVerification = this.Queuedetails.QueueVerification;
    req.transitionRuleVerification = this.Queuedetails.TransitionRuleVerification;
    req.retainForwardingUser = this.Queuedetails.RetainForwardingUser;
    req.queueType = this.Queuedetails.QueueType;
    req.toQueueName = this.Queuedetails.ToQueueName;
    req.isAdvDocApprovalFromWebsite = this.isAdvanceDoc;
    req.documentId = Number(this.docId);
  }

  private routeWorkItem(routeWorkItemRequest: MoveWorkItemDto, item: TransitionRules | string): void {
    this.documentViewerServices.routeWorkItem(routeWorkItemRequest).subscribe({
      next: (response: any[]) => {
        this.isLoading = false;
        if (response) {
          const result = response[0];
          if (result === 1) {
            localStorage.setItem('workbasketDocViewer', 'true');
            localStorage.setItem('routedWorkItem', JSON.stringify(this.Queuedetails));
            this.error = false;
            setTimeout(() => this.getNextWorkItem(), 500);
          } else if (result === 2 || result === 3) {
            this.Workitemdetails = item;
            this.showViewNotes();
          } else {
            this.isDynamicMandatoryActive = true; 
            // Update isMandatory on FormGroup controls so the UI and validation reflect changes (not just raw values).
            for (let i = 0; i < this.fieldArray.length; i++) {
              const control = this.fieldArray.at(i);
              const field = control.value;
              if (response.includes(field.id)) {
                control.patchValue({ isMandatory: true });
              }
            }
            this.error = true;
            this.commonService.showMessage("Highlighted mandatory fields needs to be filled", "error");
            this.selectedQueue = '';
          }
          this.isRoutingComplete = true;
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.isRoutingComplete = true;
        this.errorModalPopUp("ERROR", err?.error.message);
      }
    });
  }

  isDateOnlyInFormat(value: string, format: string): boolean { 
    return value.length == format.length;
  }
  
  prepareIndexingFieldsToSave(): IndexFields[] {
    const amountFields = ['APPROVED_AMOUNT', 'NET_AMOUNT', 'TOTAL', 'TOTAL_NET_AMOUNT', 'TOTAL_TAX_AMOUNT', 'TAX_AMOUNT1', 'TAX_AMOUNT2', 'NET_AMOUNT1', 'NET_AMOUNT2'];
    
    let saveIndexFields = this.documentIndexFieldValues.filter(field => field.controlName !== 'LABEL')
      .map(field => {
        if (field.controlName === 'DATE' && field.valueAsString) {
          const dateObj = new Date(field.valueAsString);
          const timeValue = field.timeValue ?? '00:00:00';
          const rawFormat = field.fieldDateFormat?.defaultFormat || 'dd/MM/yyyy HH:mm:ss';
          const momentFormat = this.dateService.toMomentFormat(rawFormat);
          const [h, m, s] = timeValue.split(':').map(Number);
          dateObj.setHours(h, m, s);
          field.valueAsString = moment(dateObj).format(momentFormat);
          field.valueAsString = field.valueAsString.split(' ')[0];
        }
        if (field.controlName === 'CHECK_BOX') {
          if (typeof field.valueAsString === 'boolean') {
            field.valueAsString = (field.valueAsString as any) ? 'true' : 'false';
          }
        }
        // Replace commas with dots for specific amount fields
        if (amountFields.includes(field.columnName) && field.valueAsString && typeof field.valueAsString === 'string') {
          field.valueAsString = field.valueAsString.replace(/,/g, '.');
        }
        if (field.columnName === 'IS_CODING_CHANGED' && this.isCodingFieldUpdateRequired && this.isGLEntrySaved) {
          field.valueAsString = 'Yes';
          this.documentIndexFieldValues.forEach((obj: any) => {
            if (obj.columnName === 'IS_CODING_CHANGED') {
              obj.valueAsString = 'Yes';
            }
          });
          const fieldControl = this.fieldArray.controls.find(ctrl => ctrl.value.columnName === 'IS_CODING_CHANGED');
          const valueControl = fieldControl?.get('valueAsString');
          if (valueControl) {
            valueControl.patchValue('Yes', { emitEvent: false });
          }
        }
        return field;
      });
    return saveIndexFields;
  }

  getNextWorkItem(): void { 
   this.isLoading = true;
   this.loaderMsg = "Checking if next work item is available";
    setTimeout(() => {
      this.checkForNextWorkItem = true;
    }, 30);

    let selDocType: any;
    let selDocTypeName: string; 
    if (this.selDocumentType !== 'all' && this.selDocumentType !== 'none' && this.selDocumentType !== '') {
      const parsed = typeof this.selDocumentType === 'string' ? JSON.parse(this.selDocumentType) : this.selDocumentType; 
      selDocType = parsed.distinctDoctypeID;
      selDocTypeName = parsed.name;
      sessionStorage.setItem('selDocTypeName', selDocTypeName);
    } else if (this.selDocumentType === 'all') {
      selDocType = 'all';
      selDocTypeName = 'All';
      sessionStorage.setItem('selDocTypeName', selDocTypeName);
    } else {
      selDocType = this.selDocumentType;
    }

    // If no selection: Close viewer (Russia-specific behavior)
    if (selDocType === '') {
      window.close();
      return;
    } else if (selDocType === 'none') {
     this.loaderMsg = "Closing Document Viewer as no option selected to get next work item."; 
      this.isNextWorkItemAvailable = false;
      sessionStorage.removeItem('selDocTypeName'); 
      setTimeout(() => {
        window.close();
      }, 1500); 
      return;
    }

    const nextWorkItemDto: NextWorkItem = {
      userGpid: this.userGPID,
      systemId: this.selectedSystemId,
      source: this.source,
      nextWorkitemSelectedComboValue: selDocType,
      workflowId: this.workFlowID,
      workflowQueueId: this.QueueId
    }
    this.documentViewerServices.getNextWorkItem(nextWorkItemDto).subscribe({
        next: (response) => {
          this.loaderMsg = "Loading next work item";
          this.isNextWorkItemAvailable = true; 
          if (response && response.queueId && response.documentId && response.batchId) {
            setTimeout(() => {
              this.checkForNextWorkItem = false;
              const newWIURL = `${environment.siteUrl}/documentViewer/${response.queueId}/${response.documentId}/${response.instanceId}/${this.pPageType}/${response.batchId}`;
              window.location.href = newWIURL;
            }, 1500);
          } else {
            this.handleNoWorkItem(this.pPageType);
          }
        },
        error: () => {
          this.checkForNextWorkItem = false;
          this.isNextWorkItemAvailable = false;
        }
      });
  }

  handleNoWorkItem(pageType: string): void {
    if (pageType === '001') {
      this.loaderMsg = "No WorkItem available for the selected option, redirecting to My Work Basket";
    } else if (pageType === '002') {
     this.loaderMsg = "No WorkItem available for the selected option, redirecting to Workflow";
    } 
    this.isNextWorkItemAvailable = false; 
    setTimeout(() => {
      window.close();
    }, 1500);
  }

  closeWorkitem() {
    this.isLoading = true;
    if (!this.isRetrieval) {
      this.documentViewerServices.workItemLockUnLock(this.userGPID, this.selectedSystemId, this.userGPID, this.pInstanceId, 0)
        .subscribe({
          next: (response: any) => { 
            if (response) {
              this.processWorkItemStatus();
            }

            this.isLoading = false;
          },
          error: (error) => {
            this.isLoading = false;
            this.errorModalPopUp("", "Error While unlocking workitem");
          }
        });
    } else {
      this.isLoading = false;
      window.close();
    }
  }

  processWorkItemStatus() {
    const postObj = new ReAssignReleaseDto();
    const assignmentWorkItem = [];
    assignmentWorkItem.push(this.pInstanceId);
    postObj.systemId = this.selectedSystemId;
    postObj.userGpid = this.userGPID;
    postObj.workItemId = assignmentWorkItem;
    postObj.queueId = Number(this.pQueueId);
    postObj.workFlowId = this.workFlowID;
    postObj.owningUser = "";
    postObj.assignUserGpid = this.owningUser;

    this.workflowService.assignReleaseWorkItem(postObj).subscribe({
      next: (response) => {
        this.AssignedUser = this.userGPID;
        localStorage.setItem("AssignedUser", JSON.stringify(this.AssignedUser));
        window.close();
      },
      error: (error) => {
        this.errorModalPopUp("Error while assigning work items.", error.error.message);
      }
    }); 
  }

  // Top buttons functionalities starts from here
  downloadWorkItem() {
    this.documentViewerServices.downloadWorkItem(this.userGPID, this.selectedSystemId, this.pDocId).subscribe({
      next: (response: any) => {
        const updatedUrl = response.replace(environment.apiBaseUrl, environment.siteUrl);
        window.open(updatedUrl + '/' + this.selectedDocument?.imageId);
      },
      error: (error: any) => {
        this.commonService.showMessage("Error in loading download link.", "error");
        console.error("Error while downloading work item.", error);
      }
    });
  }

  showEmailModal() {
    if (this.isBatchSelected) {
      this.emailInfo.id = this.pBatchId;
      this.emailInfo.type = "batch";
      this.emailInfo.userGpid = this.userGPID;
      this.emailInfo.systemId = this.selectedSystemId;
    }
    else {
      this.emailInfo.id = this.pDocId;
      this.emailInfo.type = "document";
      this.emailInfo.userGpid = this.userGPID;
      this.emailInfo.systemId = this.selectedSystemId;
    }
    const data = this.emailInfo;
    this.dialog.open(SendEmailComponent, {
      width: '600px',
      disableClose: true,
      data: data
    });
  }

  copyLink() {
    if (!this.pDocId) { return; }
    let message: string = "";
    if (this.isBatchSelected) {
      this.documentViewerServices.getDocumentLink(this.userGPID, this.selectedSystemId, this.pBatchId, "batch").subscribe({
        next: (response: string) => {
          navigator.clipboard.writeText(response).then(() => {
            message = "Link is copied. Link : " + response;
            this.commonService.showMessage(message, 'success');
          }).catch(err => {
            console.error('Failed to copy link: ', err);
          });
        },
        error: (error) => {
          console.error('Not able to fetch the business area', error);
        }
      });
    } else {
      this.documentViewerServices.getDocumentLink(this.userGPID, this.selectedSystemId, this.pDocId, "document").subscribe({
        next: (response: string) => {
          navigator.clipboard.writeText(response).then(() => {
            message = "Link is copied. Link : " + response;
            this.commonService.showMessage(message, 'success');
          }).catch(err => {
            console.error('Failed to copy link: ', err);
          });
        },
        error: (error) => {
          console.error('Not able to fetch the business area', error);
        }
      });
    }
  }

  showWIEmailModal() {
    throw new Error('Method not implemented.');
  }

  uploadFileWorkItem() {
    if (!this.pDocId) return;
    const userGpid = this.userGPID;
    const systemId = this.selectedSystemId;
    const DOCID = this.pDocId;
    const dialogData = {
      documentId: DOCID,
      userGpid: userGpid,
      systemId: systemId,
    };
    const dialogRef = this.dialog.open(AddAttachmentComponent, {
      width: '700px',
      height: '300px',
      maxWidth: '100%',
      data: dialogData,
      disableClose: false,
      autoFocus: true
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadDocuments();
      }
    });
  }

  showViewNotes() {
    if (!this.pDocId) return;
    const userGpid = this.globalVariable.getUserGPID;
    const systemId = this.globalVariable.getSelectedSystemId;
    const DOCID = this.pDocId;
    const items = this.pInstanceId;
    const BatchId = this.pBatchId;
    const dialogData = {
      DocumentId: DOCID,
      userGpid: userGpid,
      systemId: systemId,
      items: items,
      BatchId: BatchId,
      Type: this.workFlowNotesMenu == "View / Add Workflow Notes" ? 'viewandadd' : 'view'
    };
    this.dialog.open(ViewWorkflowNotesComponent, {
      width: '85%',
      height: '600px',
      maxWidth: '100%',
      maxHeight: 'max-content',
      data: dialogData
    });
  }

  showDocumentNotesAdmin() {
    if (!this.pDocId) return;
    const userGpid = this.globalVariable.getUserGPID;
    const systemId = this.globalVariable.getSelectedSystemId;
    const DOCID = this.pDocId;
    const dialogData = {
      DocumentId: DOCID,
      userGpid: userGpid,
      systemId: systemId,
      Type: this.documentNotesMenu == "View / Add Document Notes" ? 'viewandadd' : 'view'
    };
    this.dialog.open(ViewAddDocNotesComponent, {
      width: '85%',
      maxWidth: '100%',
      data: dialogData
    });
  }

  showDocumentHistory() {
    if (!this.pDocId) { return; }
    const userGpid = this.globalVariable.getUserGPID;
    const systemId = this.globalVariable.getSelectedSystemId;
    const documentId = this.pDocId;
    this.retrievalService.getDocumentHistory(userGpid, systemId, documentId).subscribe({
      next: (response: DocumentHistoryResponse) => {
        const dialogData = {
          documentId: documentId,
          batchId: response.batchId,
          createDate: response.createDate,
          docHistoryDtoList: response.docHistoryDtoList || []
        };
        this.dialog.open(DocumentHistoryDialogComponent, {
          width: '85%',
          height: '1060px',
          maxWidth: '100%',
          maxHeight: 'max-content',
          data: dialogData
        });
      },
      error: (error) => {
        console.error('Not able to fetch the document history:', error);
      }
    });
  }

  showViewHistory() {
    if (!this.pDocId) { return; }
    const userGpid = this.globalVariable.getUserGPID;
    const systemId = this.globalVariable.getSelectedSystemId;
    const Id = this.isBatchSelected ? this.pBatchId : this.pDocId;
    this.documentViewerServices.getWorkflowHistory(userGpid, systemId, Id, this.isBatchSelected).subscribe({
      next: (response: WorkflowHistoryResponse[]) => {
        this.dialog.open(WorkflowHistoryDialogComponent, {
          width: '85%',
          height: '485px',
          maxWidth: '100%',
          maxHeight: 'max-content',
          data: response
        });
      },
      error: (error: any) => {
        console.error('Failed to fetch workflow history:', error);
      }
    });
  }
 
  showBranchView() {
    this.isBatchViewLoading = true;
    this.documentViewerServices.getBatchDocuments(this.userGPID, this.selectedSystemId, this.pBatchId).subscribe({
      next: (response: BatchDocuments) => {
        this.isBatchViewLoading = false;
        this.dataSource = [{
            name: 'Batch',
            value: response.batchId,
            children: (response.childDocuments ?? []).map(doc => ({
              name: 'Document',
              value: doc.documentId
            }))
          }];
        this.expandedNodeIds.add(String(this.dataSource[0].value));
        this.cdr.detectChanges();
      },
      error: (error) => {
        this.isBatchViewLoading = true;
        console.error('Error loading batch documents', error);
      }
    });
  }

  private validateMandatoryFields(fromQueueId: number, toQueueId: number): boolean {
    let mandatoryTriggered = false;
    const isEInvoice = this.isEInvoiceTransition(fromQueueId, toQueueId);

    this.clearDynamicMandatoryFields();

    const rules = this.queueTransitionMandatoryRules[Number(this.globalVariable.getSelectedSystemId)];

    // Find rules matching current queue transition
    for (const rule of rules) {
      const isMatchingRule = this.isReturnClicked
        ? rule.isReturn && rule.fromQueueId === fromQueueId
        : !rule.isReturn &&
          rule.fromQueueId === fromQueueId &&
          rule.toQueueId === toQueueId;

      if (!isMatchingRule) {
        continue;
      }

      if (rule.fromQueueId === fromQueueId && rule.toQueueId === toQueueId) { 
        // BU ID/Company Code and VendorLegalNumber Fields are mandatory only for EInvoice Document Source. Skip mandatory check for these fields if not EInvoice.
        if ((rule.fieldId === 1534 || rule.fieldId === 1517) && !isEInvoice) {
          continue;
        }
        // Loop through FormArray controls directly, since documentIndexFieldValues is based on getRawValue(), which returns a static snapshot and doesn't reflect live updates.
        this.fieldArray.controls.forEach((control: AbstractControl) => {
          const fieldValue = control.value;

          if (fieldValue.id === rule.fieldId && fieldValue.valueAsString === '') {
            control.patchValue({ isMandatory: true });
            this.dynamicMandatoryFieldIds.push(fieldValue.id);
            mandatoryTriggered = true;
          }
        });
      }
    }

    if (mandatoryTriggered) {
      this.isDynamicMandatoryActive = true;
      this.error = true;
      this.commonService.showMessage('Highlighted mandatory fields need to be filled', 'error');
    }

    return !mandatoryTriggered;
  }

  private isEInvoiceTransition(fromQueueId: number, toQueueId: number): boolean {

    if(this.globalVariable.getSelectedSystemId === '6002') {
      if (fromQueueId === 515 && (toQueueId === 516 || toQueueId === 517)) {
        const documentSource = this.documentIndexFieldValues.find(f => f.columnName === 'DOCUMENT_SOURCE')?.valueAsString;
          return documentSource === 'EInvoice';
      }
    }
    return false;

  }

  private clearDynamicMandatoryFields(): void {
    if (!this.isDynamicMandatoryActive) {
      return;
    }

    this.dynamicMandatoryFieldIds.forEach(fieldId => {
      const field = this.documentIndexFieldValues.find(item => item.id === fieldId);

      if (field) {
        field.isMandatory = false;

        const control = this.fieldArray.controls.find(item => item.value.id === field.id);

        if (control) {
          control.patchValue({ isMandatory: false });
        }
      }
    });

    this.dynamicMandatoryFieldIds = [];
    this.isDynamicMandatoryActive = false;
  }
}

